import React, { useCallback, useEffect, useRef, useMemo } from "react";
import { toast } from "react-toastify";
import { DetailPageLoadingModalContext } from "../../../../ContextAPI/context";
import {
  ControlClass,
  ControlTypes,
  // OfflineDefaultPayerAccount, // dead: offline default now from API (result.offlineDefaultAccount)
  OfflinePayModeValues,
  OfflinePaymentModes,
  ReasonForDeviation,
  RphUserIds,
  paymentMode,
} from "../../../../utils/constant";
import { useSelector } from "react-redux";
import SingleSelectDropDown from "../../../../layouts/SingleSelectDropDown";
import RadioButtons from "../../../../layouts/RadioButtons";
import { formatAmount } from "../../../../utils/format";
import MultiSelectDropDown from "../../../../layouts/MultiSelectDropDown";
import {
  checkPayeeNameHavAcc,
  compareTrancheDetails,
  getOfflinePayeeName,
  maskPayeeAccountText,
  maskString,
} from "../../../../utils/helperFunctions";
import { axios_instance } from "../../../../api/axios_instance";
import {
  autoFillByIfsc,
  getPayerAcVal,
  removeErrorClass,
  resetDealerProfileFields,
  resetPartnerProfileFields,
  resetPaymentPrefillFields,
} from "../../../../utils/TrancheFormFunctions";
import FormTriggers from "../../../../layouts/FormTriggers";
import RefreshButton from "./RefreshButton";
import {
  decryptRequest,
  encryptRequest,
} from "../../../../utils/encryptdecryptrequest";

const AddedTranche = ({
  data,
  fieldValues,
  controlSystem,
  floatResp,
  formFieldState,
  setFormFieldState,
  state,
  setState,
  fetchBalAmount,
  toggleCancellationTooltip,
  handleRadioChange,
  handleTriggerChange,
  refreshFloatRuleFunc,
  addUTR,
  ifscMappingFunc,
  changeAccTypeFunc,
  validateAccNumberFunc,
  compareLedgerWithDisbAmtFunc,
  checkpoints,
  handleFloatProofUpload,
  handleFloatProofDelete,
}) => {
  const { caseDetails, isTMSUser } = fieldValues;
  const { finance_lead_id, disbursement_id, count, tuTrancheNo } = data;
  const disableMaker = false,
    disableRadioCls = "";
  const payCount = count,
    idx = count - 1;
  const user = useSelector((state) => state.user);

  const dropdownContainer = useRef(null);
  const dropdownContainers = useMemo(
    () => [dropdownContainer],
    [dropdownContainer],
  );

  const showPreviousLoanDetails = false;

  const fetchData = async () => {
    try {
      const response = await axios_instance({
        url: "/dts/addedTrancheDetails",
        method: "POST",
        data: {
          finance_lead_id,
          count,
          tuTrancheNo,
          disbursement_id: caseDetails.id,
          caseDetails,
        },
      });

      if (response.status === 200) {
        const {
          tranche_details: tuDetailResp,
          cancellation_data: cancellationDataResp,
          tranche_name_list: trancheNameListResp,
          float_status_resp,
        } = response.data;

        const tranche_name = { selected: {}, deselected: {} };

        trancheNameListResp?.forEach(({ isChecked, label, amount }) => {
          if (isChecked) {
            tranche_name.selected[label] = amount;
          } else {
            tranche_name.deselected[label] = amount;
          }
        });

        const trancheCancellationData = cancellationDataResp.length
          ? cancellationDataResp[cancellationDataResp.length - 1]
          : {};

        const tuTrancheDetails = tuDetailResp.tuDetail;

        // const autoPopularField =
        //   tuTrancheDetails.length &&
        //   ["1", "7"].includes(tuTrancheDetails[0].payment_to)
        //     ? false
        //     : true;
        const autoPopularField = true;
        let net_amount = data.net_amount,
          paid_amount = data.net_amount,
          defaultPayeeType = "",
          payee_name = formFieldState[idx].payee_name
            ? formFieldState[idx].payee_name
            : "";
        formFieldState[idx].payableDis = false;
        formFieldState[idx].payModeDis = false;
        if (tuTrancheDetails.length && autoPopularField) {
          const tranche = tuTrancheDetails[0];

          defaultPayeeType = tranche.payment_to;
          payee_name = tranche.account_name;
          paid_amount = tranche.tranche_amount;
          formFieldState[idx].payee_ac_number = tranche.account_no;
          formFieldState[idx].payee_ifsc_code = tranche.ifsc_code;
          formFieldState[idx].payee_bank_name = tranche.bank_name;
          formFieldState[idx].payee_branch_name = tranche.branch_name;
          formFieldState[idx].is_payment_received_by_bank =
            tranche.is_payment_received_by_bank || 0;
          formFieldState[idx].float_doc_id = tranche.float_doc_id || 0;
          if (+tranche.payment_type === 1) {
            formFieldState[idx].payable_ac_number = "Direct Payment";
            formFieldState[idx].payableDis = true;
          }
          if ([2, 3, 4].includes(+tranche.payment_type)) {
            formFieldState[idx].payment_mode =
              OfflinePayModeValues[+tranche.payment_type];
            formFieldState[idx].payable_ac_number =
              state.offlineDefaultAccount || "HDFC(50200091661248)";
            formFieldState[idx].payModeDis = true;
          }
          const detail = {
            payment_type: tranche.payment_type,
            payee_name: tranche.account_name,
            payee_account: tranche.account_no,
            payee_type: tranche.payment_to,
            is_account_no_optional: tranche.is_account_no_optional,
          };

          const offlinePayeeName = getOfflinePayeeName(detail);
          payee_name = offlinePayeeName
            ? offlinePayeeName
            : tranche.account_name;
        }

        if (isTMSUser) {
          try {
            const response = await axios_instance({
              url: "/dts/getPartnerProfile",
              method: "POST",
              data: {
                lead_id: caseDetails.finance_lead_id,
                customer_id: caseDetails.customer_id,
              },
            });
            if (response.status === 200) {
              const result = response.data.result;
              defaultPayeeType = result.payee_type;
              payee_name = result.payee_name;
              formFieldState[idx].payee_ac_number = result.payee_account;
              formFieldState[idx].payee_ifsc_code = result.ifsc_code;
              formFieldState[idx].payee_bank_name = result.bank;
              formFieldState[idx].payee_branch_name = result.branch;
            } else {
              defaultPayeeType = "";
              payee_name = "";
              resetPartnerProfileFields(idx, formFieldState);
            }
          } catch (error) {
            defaultPayeeType = "";
            payee_name = "";
            resetPartnerProfileFields(idx, formFieldState);
          }
        }

        const trancheNameListData = trancheNameListResp;
        let totalWithheldCharges = 0;
        trancheNameListData.forEach((data) => {
          totalWithheldCharges += data.isChecked ? 0 : +data.amount;
        });
        setState((prevState) => ({ ...prevState, totalWithheldCharges }));

        formFieldState[idx] = {
          ...formFieldState[idx],
          paidAmountVal: paid_amount,
          netAmountVal: net_amount,
          payeeTypeVal: defaultPayeeType,
          payeeNameVal: payee_name,
          tranche_name,
          tuTrancheDetails: tuDetailResp.tuDetail,
          transactionUndertaking: tuDetailResp.transactionUndertaking,
          cancellationData: trancheCancellationData,
          trancheNameListData,
          cancellationChargesVal:
            trancheCancellationData.cancellationChargesVal,
          money_returned_to_bank:
            parseInt(paid_amount) +
            parseInt(trancheCancellationData.cancellationChargesVal) +
            parseInt(trancheCancellationData.recovered_amount),
          recovered_amount: parseInt(trancheCancellationData.recovered_amount),
        };

        formFieldState[idx].floatResp = float_status_resp || floatResp;
        formFieldState[idx].float_status = float_status_resp
          ? float_status_resp.float_status
          : floatResp
            ? floatResp.float_status
            : 0;
        formFieldState[idx].float_doc_id =
          formFieldState[idx].float_doc_id ||
          (float_status_resp
            ? float_status_resp.document_id
            : floatResp
              ? floatResp.document_id
              : 0);

        const currentFloatStatusVal = float_status_resp
          ? float_status_resp.float_status
          : floatResp
            ? floatResp.float_status
            : 0;
        const isProofUploadedVal = float_status_resp
          ? float_status_resp.is_proof_uploaded
          : floatResp
            ? floatResp.is_proof_uploaded
            : false;
        // formFieldState[idx].is_payment_received_by_bank =
        //   +currentFloatStatusVal === 1 || isProofUploadedVal
        //     ? 1
        //     : formFieldState[idx].is_payment_received_by_bank || 0;

        fetchBalAmount(idx, trancheNameListData, false, true, true);

        setFormFieldState((prevState) => [...prevState]);
      }
    } catch (error) {}
  };

  const closeAllDropdowns = useCallback(
    (target) => {
      dropdownContainers
        .filter((container) => container !== target)
        .forEach((container) => {
          const ul = container.current;
          if (ul && ul.classList.contains("visible")) {
            ul.classList.remove("visible");
            ul.style.display = "none";
          }
        });
    },
    [dropdownContainers],
  );

  const handleDocumentClick = useCallback(
    (e) => {
      if (
        !dropdownContainers.some(
          (container) =>
            container.current && container.current.contains(e.target),
        )
      ) {
        closeAllDropdowns();
      }
    },
    [dropdownContainers, closeAllDropdowns],
  );
  useEffect(() => {
    if (!formFieldState[idx]?.payment_mode) {
      fetchData();
    }
    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [handleDocumentClick]);

  const toggleDropDown = (container, e) => {
    closeAllDropdowns(container);
    const ul = container.current;
    if (ul.classList.contains("visible")) {
      ul.classList.remove("visible");
      ul.style.display = "none";
    } else {
      ul.classList.add("visible");
      ul.style.display = "block";
    }
    e.stopPropagation();
  };

  const toggleUTRButton = (e) => {
    e.preventDefault();
    formFieldState[idx].showUTRButton = !formFieldState[idx].showUTRButton;
    setFormFieldState([...formFieldState]);
  };

  const handleCheckboxChange = (e, filterName) => {
    const { name, checked } = e.target;

    const disbursePayableAmt = formFieldState[idx].netAmountVal;
    let withheldCharges = 0,
      temp = [],
      balAmount = 0,
      tranche_value = 0,
      tranche_name = {},
      totalWithheldCharges = 0;
    if (name === "selectall") {
      temp = formFieldState[idx][filterName].map((value) => {
        if (!checked) {
          tranche_name.deselected = {
            ...tranche_name.deselected,
            [value.label]: value.amount,
          };

          totalWithheldCharges += parseInt(value.amount);
        } else {
          tranche_name.selected = {
            ...tranche_name.selected,
            [value.label]: value.amount,
          };

          tranche_value += parseInt(value.amount);
          withheldCharges += parseInt(value.amount);
        }
        return { ...value, isChecked: checked };
      });
    } else {
      temp = formFieldState[idx][filterName].map((value) => {
        let chk = value.isChecked;
        if (value.label === name) chk = checked;

        if (!chk) {
          tranche_name.deselected = {
            ...tranche_name.deselected,
            [value.label]: value.amount,
          };

          totalWithheldCharges += parseInt(value.amount);
        } else {
          tranche_name.selected = {
            ...tranche_name.selected,
            [value.label]: value.amount,
          };

          tranche_value += parseInt(value.amount);
          withheldCharges += parseInt(value.amount);
        }
        return value.label === name ? { ...value, isChecked: checked } : value;
      });
    }

    balAmount = parseInt(disbursePayableAmt) - withheldCharges;

    setState({ ...state, totalWithheldCharges });

    formFieldState[idx] = {
      ...formFieldState[idx],
      paidAmountVal: withheldCharges,
      disburse_bal_amt: balAmount,
      with_held_charges: balAmount,
      tranche_name,
      tranche_value,
      [filterName]: temp,
    };
    setFormFieldState([...formFieldState]);
  };
  const trancheCancellationData = formFieldState[idx].cancellationData
    ? formFieldState[idx].cancellationData
    : {};

  let disableValues = true;
  const isCancellation = Object.keys(trancheCancellationData).length > 1;
  if (isCancellation) {
    disableValues = false;
  }

  const handleInputChange = async (e, inputName) => {
    let { value, type } = e.target;
    if (inputName === "payment_mode") {
      // if (["DD", "ECHK", "CHK"].includes(value)) {
      //   formFieldState[idx].forceEditable = true;
      //   resetPaymentPrefillFields(idx, formFieldState);
      // } else {
      try {
        // let trancheNo = false;
        // if (+formFieldState[idx]?.payeeTypeVal === 7) {
        //   trancheNo = true;
        // }
        const response = await axios_instance({
          url: "/dts/getPrefillTUTranchewiseData",
          method: "POST",
          data: {
            lead_id: caseDetails?.finance_lead_id,
            // tranche_no: trancheNo ? "-1" : tuTrancheNo,
            tranche_no: tuTrancheNo,
          },
        });
        if (response.status === 200) {
          const result = response.data.result;

          let offlinePayeeName = "";
          if (["DD", "ECHK", "CHK"].includes(value) && disableValues) {
            offlinePayeeName = getOfflinePayeeName(result);
          }

          formFieldState[idx].payeeTypeVal = result.payee_type;
          formFieldState[idx].payeeNameVal = offlinePayeeName
            ? offlinePayeeName
            : result?.payee_name;
          formFieldState[idx].payee_ac_number = result.payee_account;
          formFieldState[idx].payee_ifsc_code = result.ifsc_code;
          formFieldState[idx].payee_bank_name = result.bank;
          formFieldState[idx].payee_branch_name = result.branch;
          const fieldMapping = {
            payableAcNumber: result.payee_account,
            paymentMode: result.payee_type,
            payeeType: result.payee_type,
            payeeName: result.payee_name,
            payeeAccountNo: result.payee_account,
            confirmPayeeAcNumber: result.payee_account,
            payeeIFSC: result.ifsc_code,
            payeeBankName: result.bank,
            payeeBranchName: result.branch,
          };

          Object.entries(fieldMapping).forEach(([classId, value]) => {
            if (value && value !== "") {
              removeErrorClass(
                idx,
                classId,
                formFieldState,
                setFormFieldState,
                true,
              );
            }
          });
        } else {
          resetPaymentPrefillFields(idx, formFieldState);
        }
      } catch (error) {
        resetPaymentPrefillFields(idx, formFieldState);
      }
      formFieldState[idx].forceEditable = false;
      setFormFieldState([...formFieldState]);
      // }

      formFieldState[idx].selectedTranche = tuTrancheNo;
    }
    if (inputName === "payable_ac_number") {
      formFieldState[idx][inputName] = value;
      await changeAccTypeFunc(idx);
      return setFormFieldState([...formFieldState]);
    }

    if (inputName === "payeeTypeVal") {
      value = parseInt(value);
      if (!isTMSUser) {
        if ([1, 7, 9].includes(value)) {
          try {
            const response = await axios_instance({
              url: "/dts/getDealerProfile",
              method: "POST",
              data: {
                lead_id: caseDetails.finance_lead_id,
                dealer_id: caseDetails.dealer_id,
                payee_type_val: value,
              },
            });
            if (response.status === 200) {
              const result = response.data.result;
              formFieldState[idx].payeeNameVal = result.payee_name;
              formFieldState[idx].payee_ac_number = result.payee_account;
              formFieldState[idx].payee_ifsc_code = result.ifsc_code;
              formFieldState[idx].payee_bank_name = result.bank;
              formFieldState[idx].payee_branch_name = result.branch;
              await autoFillByIfsc(idx, result.ifsc_code, formFieldState);
            } else {
              resetDealerProfileFields(idx, formFieldState);
            }
          } catch (error) {
            resetDealerProfileFields(idx, formFieldState);
          }
        } else {
          resetDealerProfileFields(idx, formFieldState);
        }
      }
      formFieldState[idx][inputName] = value;
      await getPayerAcVal(idx, formFieldState, caseDetails);
      return setFormFieldState([...formFieldState]);
    }

    formFieldState[idx][inputName] = value;
    if (!["text", "password"].includes(type))
      await getPayerAcVal(idx, formFieldState, caseDetails);
    setFormFieldState([...formFieldState]);
  };

  const cancellationCharges =
    trancheCancellationData.is_approval_required === 1
      ? trancheCancellationData.approved_cancellation_charges
      : trancheCancellationData.cancellation_charges;

  let trancheNo = "";
  if (payCount === 1) {
    trancheNo = "1st";
  } else if (payCount === 2) {
    trancheNo = "2nd";
  } else if (payCount === 3) {
    trancheNo = "3rd";
  } else {
    trancheNo = `${payCount}th`;
  }

  let trancheTypeCls = "",
    trancheType = "";
  if (data.tranche_type !== "0" && !RphUserIds.includes(user.id)) {
    trancheType = data.tranche_type
      ? ControlTypes[data.tranche_type]
      : controlSystem.type;
    trancheTypeCls = data.tranche_type
      ? ControlClass[data.tranche_type]
      : ControlClass[ControlTypes.indexOf(controlSystem.type)];
  }

  const transactionUndertaking = formFieldState[idx].transactionUndertaking;
  const tuComparable =
    formFieldState[idx].payee_type &&
    transactionUndertaking[idx] &&
    transactionUndertaking[idx][formFieldState[idx].payee_type]
      ? formFieldState[idx].transactionUndertaking[idx][
          formFieldState[idx].payee_type
        ]
      : [];
  const payeetypeList = [...state.payeeTypeList];
  payeetypeList.unshift({
    text: "Select Payee Type",
    value: "",
  });

  let defaultPayeeType = formFieldState[idx].payeeTypeVal;

  let payeeName = `payee_name_${payCount}`;
  let payee_name = formFieldState[idx].payeeNameVal
    ? formFieldState[idx].payeeNameVal
    : "";

  let net_amount = formFieldState[idx].netAmountVal,
    paid_amount = formFieldState[idx].paidAmountVal;

  paid_amount = parseInt(paid_amount);

  const disburse_payable_amt = `disburse_payable_amt_${payCount}`;
  const disburse_paid_amt = `disburse_paid_amt_${payCount}`;

  const payable_ac_number = `payable_ac_number_${payCount}`;
  const devitionReasonId = `devition_reason_id_${payCount}`;

  const previousFinancier = `previous_financier_${payCount}`;
  const previous_financier = formFieldState[idx].previous_financier
    ? formFieldState[idx].previous_financier
    : "";

  const tuMatchFinancier = compareTrancheDetails(
    caseDetails,
    tuComparable,
    previousFinancier,
    previous_financier,
    formFieldState[idx].save_as_draft,
    user.id,
  );

  const previousLoanAccount = `previous_loan_account_${payCount}`;
  const previous_loan_account = formFieldState[idx].previous_loan_account
    ? formFieldState[idx].previous_loan_account
    : "";

  const tuMatchLoanAccount = compareTrancheDetails(
    caseDetails,
    tuComparable,
    previousLoanAccount,
    previous_loan_account,
    formFieldState[idx].save_as_draft,
    user.id,
  );

  const payeeAccountNo = `payee_ac_number_${payCount}`;
  const payee_ac_number = formFieldState[idx].payee_ac_number
    ? formFieldState[idx].payee_ac_number
    : "";

  const tuMatchPayeeAcNumber = compareTrancheDetails(
    caseDetails,
    tuComparable,
    payeeAccountNo,
    payee_ac_number,
    formFieldState[idx].save_as_draft,
    user.id,
  );

  const payeeIFSC = `payee_ifsc_code_${payCount}`;
  const payee_ifsc_code = formFieldState[idx].payee_ifsc_code
    ? formFieldState[idx].payee_ifsc_code
    : "";

  const payeeBankName = `payee_bank_name_${payCount}`;
  const payee_bank_name = formFieldState[idx].payee_bank_name
    ? formFieldState[idx].payee_bank_name
    : "";

  const payeeBranch = `payee_branch_name_${payCount}`;
  const payee_branch_name = formFieldState[idx].payee_branch_name
    ? formFieldState[idx].payee_branch_name
    : "";

  const disburseBalAmount = `disburse_bal_amt_${payCount}`;
  const balAmount = formFieldState[idx].disburse_bal_amt
    ? formFieldState[idx].disburse_bal_amt
    : "0";

  const spanBalAmount = `span_bal_amt_${payCount}`;

  const with_held_charges = formFieldState[idx].with_held_charges;

  const payableRtgsChequeNumber = `payable_rtgs_cheque_number_${payCount}`;

  const cheque = formFieldState[idx].payable_rtgs_cheque_number
    ? formFieldState[idx].payable_rtgs_cheque_number
    : "";

  const trancheName = `tranche_${payCount}`;

  const localFloatResp = formFieldState[idx].floatResp;
  // const disableFloatButtons = true;
  const disableUploadButton = localFloatResp?.is_proof_uploaded;
  const currentFloatStatus = +localFloatResp?.float_status || 0;

  return (
    <>
      <h4 className="tranche-title">
        {trancheNo} Tranche
        <span className={`label control-status-button ${trancheTypeCls}`}>
          {trancheType}
        </span>
      </h4>
      <table className="table table-striped table-bordered">
        <tbody>
          {formFieldState[idx].payable_ac_number !== "Direct Payment" ? (
            <tr className={`pay-details-hide-${payCount}`}>
              {caseDetails.maker_id &&
              user.id === caseDetails.maker_id &&
              ["2", "3", "4", "12", "14"].includes(caseDetails.sub_stage) &&
              caseDetails.stage === "1" ? (
                <td
                  className="td-float"
                  style={{
                    color: localFloatResp ? localFloatResp.float_color : "",
                  }}
                >
                  <input
                    type="hidden"
                    name="float_status"
                    id="float_status"
                    value={localFloatResp ? localFloatResp.float_status : ""}
                    readOnly
                  />
                  <strong
                    style={{
                      fontSize: "14px",
                    }}
                  >
                    Float Payment
                  </strong>
                  <br />
                  <span
                    id="float_msg_id"
                    style={{
                      fontSize: "12px",
                    }}
                  >
                    {localFloatResp ? localFloatResp.float_msg : ""}
                  </span>
                </td>
              ) : (
                <td>
                  <strong
                    style={{
                      fontSize: "14px",
                    }}
                  >
                    Float Payment
                  </strong>
                </td>
              )}
              <RadioButtons
                label=""
                isRequired={false}
                className={`btn tog-btn tog-positive ${
                  formFieldState[idx].is_payment_received_by_bank === 1
                    ? "active"
                    : ""
                }`}
                name={`payment_received_by_bank${payCount}`}
                disabled={disableMaker}
                yesChecked={
                  formFieldState[idx].is_payment_received_by_bank === 1
                }
                noChecked={
                  formFieldState[idx].is_payment_received_by_bank !== 1
                }
                noButtonClassName={`btn tog-btn tog-negative ${
                  formFieldState[idx].is_payment_received_by_bank !== 1
                    ? "active"
                    : ""
                }`}
                showDiv={true}
                DivClassName={`btn-group toggle-option ${disableRadioCls}`}
                isStyledButton={true}
                onYesClicked={() => {
                  // if (disableFloatButtons) return;
                  handleRadioChange(1, idx, "is_payment_received_by_bank");
                }}
                onNoClicked={() => {
                  // if (disableFloatButtons) return;
                  handleRadioChange(0, idx, "is_payment_received_by_bank");
                }}
                child={
                  user.id === caseDetails.maker_id &&
                  [2, 3, 4, 12, 14].includes(+caseDetails.sub_stage) &&
                  +caseDetails.stage === 1 ? (
                    <>
                      {!disableUploadButton && (
                        <RefreshButton
                          refreshFloatRule={async () => {
                            const result = await refreshFloatRuleFunc(
                              null,
                              idx,
                            );
                            if (
                              result &&
                              !result.error &&
                              formFieldState[idx]
                            ) {
                              formFieldState[idx].floatResp = {
                                float_color: result.float_color,
                                float_status: result.float_status,
                                float_msg: result.float_msg,
                                is_proof_uploaded:
                                  result.is_proof_uploaded ||
                                  formFieldState[idx].floatResp
                                    ?.is_proof_uploaded,
                                document_id:
                                  result.document_id ||
                                  formFieldState[idx].floatResp?.document_id,
                              };
                              formFieldState[idx].float_status =
                                result.float_status;
                              setFormFieldState([...formFieldState]);
                            }
                          }}
                          spinClass={state.spinClass}
                        />
                      )}
                      {currentFloatStatus !== 1 && (
                        <span
                          style={{
                            marginLeft: "10px",
                          }}
                        >
                          <input
                            type="file"
                            id={`floatProof_${idx}`}
                            accept=".pdf,.jpg,.jpeg,.png"
                            style={{
                              display: "none",
                            }}
                            onChange={(e) =>
                              handleFloatProofUpload(e, idx, payCount)
                            }
                          />

                          {!disableUploadButton ? (
                            <button
                              type="button"
                              className="btn btn-primary btn-sm"
                              onClick={() =>
                                document
                                  .getElementById(`floatProof_${idx}`)
                                  ?.click()
                              }
                              title="Upload Float Approval"
                            >
                              <i className="fa fa-upload"></i>
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-danger btn-sm"
                              onClick={() => handleFloatProofDelete(idx)}
                              title="Delete Float Approval"
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          )}
                        </span>
                      )}
                    </>
                  ) : formFieldState[idx].float_doc_id ? (
                    <div
                      style={{
                        textAlign: "center",
                        width: "100%",
                        marginTop: "8px",
                      }}
                    >
                      <span
                        style={{
                          color: "#d9534f",
                          backgroundColor: "#fdf2f2",
                          border: "1px solid #f5c6cb",
                          borderRadius: "4px",
                          padding: "4px 10px",
                          fontWeight: "600",
                          fontSize: "12px",
                          display: "inline-block",
                        }}
                      >
                        <span
                          className="glyphicon glyphicon-ok-sign"
                          style={{
                            marginRight: "5px",
                          }}
                        ></span>
                        Float Approval Uploaded.
                        <br />
                        Verification Required!
                      </span>
                    </div>
                  ) : null
                }
              />
              {state.addedTrancheChecklist && (
                <FormTriggers
                  triggerName={`is_payment_received_by_bank_${payCount}`}
                  disabled={false}
                  errorClass={
                    formFieldState[idx].showPaymentReceivedByBankTriggerError
                      ? "has-error"
                      : ""
                  }
                  triggerValues={checkpoints.checker}
                  caseDetails={caseDetails}
                  state={formFieldState}
                  setState={setFormFieldState}
                  handleTriggerChange={handleTriggerChange}
                />
              )}
            </tr>
          ) : (
            ""
          )}
          <tr>
            <td>
              Payee Type
              <span className="col-red">*</span>
            </td>
            <td>
              <SingleSelectDropDown
                dataArr={payeetypeList}
                handleChange={(e) => handleInputChange(e, "payeeTypeVal")}
                name={`payee_type_${payCount}`}
                disabled={disableValues}
                required={true}
                value={defaultPayeeType ? defaultPayeeType : ""}
                className={formFieldState[idx].payeeTypeClass}
              />
              <div className="errorTxt" id={`error_payee_type_${payCount}`}>
                {formFieldState[idx].errorpayeeTypeMsg}
              </div>
            </td>
            {state.addedTrancheChecklist && (
              <FormTriggers
                triggerName={`payee_type_${payCount}`}
                disabled={false}
                errorClass={
                  formFieldState[idx].showPayeeTypeTriggerError
                    ? "has-error"
                    : ""
                }
                triggerValues={checkpoints.checker}
                caseDetails={caseDetails}
                handleTriggerChange={handleTriggerChange}
              />
            )}
          </tr>
          <tr
            className={`pType-box-${payCount} payee-box-${payCount}`}
            style={
              formFieldState[idx].payeeTypeVal !== 5
                ? {
                    display: "none",
                    backgroundColor: "#fdfdfd",
                  }
                : {}
            }
          >
            <td>Reason for Deviation</td>
            <td>
              <SingleSelectDropDown
                dataArr={ReasonForDeviation}
                handleChange={(e) => handleInputChange(e, "devition_reason_id")}
                name={devitionReasonId}
                disabled={disableMaker}
                required={true}
                value={
                  formFieldState[idx].devition_reason_id
                    ? formFieldState[idx].devition_reason_id
                    : ""
                }
              />
            </td>
            {state.addedTrancheChecklist ? (
              <FormTriggers
                triggerName={devitionReasonId}
                disabled={false}
                triggerValues={checkpoints.checker}
                caseDetails={caseDetails}
                handleTriggerChange={handleTriggerChange}
              />
            ) : (
              ""
            )}
          </tr>
          {formFieldState[idx].payable_ac_number !== "Direct Payment" ? (
            <tr className={`pay-details-hide-${payCount}`}>
              <td>
                Mode <span className="col-red">*</span>
              </td>
              <td>
                <SingleSelectDropDown
                  dataArr={paymentMode}
                  handleChange={(e) => handleInputChange(e, "payment_mode")}
                  name={`payment_mode_${payCount}`}
                  disabled={
                    OfflinePaymentModes.includes(
                      formFieldState[idx].payment_mode,
                    ) && disableValues
                      ? true
                      : disableMaker
                  }
                  required={true}
                  value={
                    formFieldState[idx].payment_mode
                      ? formFieldState[idx].payment_mode
                      : (formFieldState[idx].payment_mode = "")
                  }
                  className={formFieldState[idx].paymentModeClass}
                />
              </td>
              {state.addedTrancheChecklist && (
                <FormTriggers
                  triggerName={`payment_mode_${payCount}`}
                  disabled={false}
                  errorClass={
                    formFieldState[idx].showPaymentModeTriggerError
                      ? "has-error"
                      : ""
                  }
                  triggerValues={checkpoints.checker}
                  caseDetails={caseDetails}
                  handleTriggerChange={handleTriggerChange}
                />
              )}
            </tr>
          ) : (
            ""
          )}
          <tr>
            <td width="30%">
              Payer A/C <span className="col-red">*</span>
            </td>
            <td width="45%">
              <SingleSelectDropDown
                dataArr={state.payerAccount}
                handleChange={(e) => handleInputChange(e, "payable_ac_number")}
                name={payable_ac_number}
                disabled={
                  formFieldState[idx].payableDis
                    ? formFieldState[idx].payableDis
                    : disableMaker
                }
                required={true}
                value={
                  formFieldState[idx].payable_ac_number
                    ? formFieldState[idx].payable_ac_number
                    : ""
                }
                handleClick={() => {
                  removeErrorClass(
                    idx,
                    "payableAcNumber",
                    formFieldState,
                    setFormFieldState,
                    true,
                  );
                }}
              />
              <div
                className="errorTxt"
                id={`error_payable_ac_number_${payCount}`}
              >
                {formFieldState[idx].errorpayableAcNumberMsg
                  ? formFieldState[idx].errorpayableAcNumberMsg
                  : ""}
              </div>
            </td>
            {state.addedTrancheChecklist && (
              <FormTriggers
                triggerName={`payable_ac_number_${payCount}`}
                disabled={false}
                width="25%"
                errorClass={
                  formFieldState[idx].showPayableAcNumberTriggerError
                    ? "has-error"
                    : ""
                }
                triggerValues={checkpoints.checker}
                caseDetails={caseDetails}
                handleTriggerChange={handleTriggerChange}
              />
            )}
          </tr>

          {isCancellation ? (
            <tr>
              <td width="20%">
                Tranche Name
                <button
                  type="cancellation-tooltip"
                  title="More Details"
                  onClick={() => toggleCancellationTooltip(idx)}
                >
                  <img
                    src={`${process.env.REACT_APP_STYLES_PATH}info-icon.png`}
                    alt=""
                  />
                </button>
                <div
                  className="trache_tooltip_wrapper cancellation-tooltip"
                  style={{
                    display: formFieldState[idx].showCancellationTooltip
                      ? "block"
                      : "none",
                  }}
                >
                  <div className="x_panel">
                    <div className="x_title">
                      <h2>Cancellation Detail from LoanBox</h2>
                      <div className="clearfix"></div>
                    </div>
                    <div
                      className="x_content"
                      style={{
                        padding: "0px",
                      }}
                    >
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <tbody>
                            <tr className="headings">
                              <td width="70%" className="column-title">
                                Recovered Loan Amount
                              </td>
                              <td width="30%">
                                <span className="fa fa-inr"></span>
                                {formatAmount(
                                  parseInt(
                                    trancheCancellationData.recovered_amount,
                                  ),
                                )}
                              </td>
                            </tr>
                            <tr className="headings">
                              <td width="70%" className="column-title">
                                Cancellation Charge Recieved
                              </td>
                              <td width="30%">
                                <span className="fa fa-inr"></span>
                                {formatAmount(
                                  parseInt(
                                    trancheCancellationData.cancellation_charges,
                                  ),
                                )}
                              </td>
                            </tr>
                            {trancheCancellationData.is_approval_required ===
                            "1" ? (
                              <>
                                <tr className="headings">
                                  <td width="70%" className="column-title">
                                    Total Cancellation Charge
                                  </td>
                                  <td width="30%">
                                    <span className="fa fa-inr"></span>
                                    {formatAmount(
                                      parseInt(
                                        trancheCancellationData.approved_cancellation_charges,
                                      ),
                                    )}
                                  </td>
                                </tr>
                                <tr className="headings">
                                  <td width="70%" className="column-title">
                                    Money to be returned to Bank
                                  </td>
                                  <td width="30%">
                                    <span className="fa fa-inr"></span>
                                    {formatAmount(
                                      parseInt(
                                        trancheCancellationData.total_return_amount,
                                      ),
                                    )}
                                  </td>
                                </tr>
                                <tr className="headings">
                                  <td width="70%" className="column-title">
                                    Amount to be paid from Float
                                  </td>
                                  <td width="30%">
                                    <span className="fa fa-inr"></span>
                                    {formatAmount(
                                      parseInt(
                                        trancheCancellationData.total_float_amount,
                                      ),
                                    )}
                                  </td>
                                </tr>
                              </>
                            ) : (
                              <tr className="headings">
                                <td width="70%" className="column-title">
                                  Money to be returned to Bank
                                </td>
                                <td width="30%">
                                  <span className="fa fa-inr"></span>
                                  {formatAmount(
                                    parseInt(
                                      trancheCancellationData.return_to_bank_amount,
                                    ),
                                  )}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <td width="25%">Payment Cancellation</td>
            </tr>
          ) : (
            <>
              <tr>
                <td width="30%">Tranche Name</td>

                <td width="45%">
                  <div className="ms-drpdwn">
                    <MultiSelectDropDown
                      data={formFieldState[idx].trancheNameListData}
                      handleCheckboxChange={handleCheckboxChange}
                      toggleDropDown={toggleDropDown}
                      dropdownContainer={dropdownContainer}
                      title="Tranche Name"
                      filterName="trancheNameListData"
                    />
                  </div>
                </td>
                {state.addedTrancheChecklist && (
                  <FormTriggers
                    triggerName={trancheName}
                    disabled={false}
                    errorClass={
                      formFieldState[idx].showTrancheNameTriggerError
                        ? "has-error"
                        : ""
                    }
                    triggerValues={checkpoints.checker}
                    caseDetails={caseDetails}
                    handleTriggerChange={handleTriggerChange}
                  />
                )}
              </tr>
            </>
          )}
          {showPreviousLoanDetails ? (
            <tr>
              <td>
                <div className={tuMatchFinancier.class}>
                  Previous Financier Name
                </div>
              </td>
              {!disableMaker ? (
                <td>
                  <input
                    type="text"
                    value={previous_financier ? previous_financier : ""}
                    id={previousFinancier}
                    name={previousFinancier}
                    placeholder="Previous Financier Name"
                    title="correct"
                    pattern="^[a-zA-Z][a-zA-Z ]{2,}$"
                    className="form-control"
                    onChange={(e) => handleInputChange(e, "previous_financier")}
                  />
                  <div
                    className="errorTxt"
                    id={`error_previous_financier_${payCount}`}
                  ></div>
                </td>
              ) : (
                <td>{previous_financier === "" ? "NA" : previous_financier}</td>
              )}
              {state.addedTrancheChecklist && (
                <FormTriggers
                  triggerName={previousFinancier}
                  disabled={false}
                  errorClass={
                    formFieldState[idx].showPreviousFinancierTriggerError
                      ? "has-error"
                      : ""
                  }
                  triggerValues={checkpoints.checker}
                  caseDetails={caseDetails}
                  handleTriggerChange={handleTriggerChange}
                />
              )}
            </tr>
          ) : (
            ""
          )}
          {showPreviousLoanDetails ? (
            <tr>
              <td>
                <div className={tuMatchLoanAccount.class}>
                  Previous Loan A/C No.
                </div>
              </td>
              {!disableMaker ? (
                <td>
                  <input
                    type="text"
                    value={previous_loan_account ? previous_loan_account : ""}
                    id={previousLoanAccount}
                    name={previousLoanAccount}
                    placeholder="Previous Loan A/C No."
                    title="correct"
                    className="form-control"
                    onChange={(e) =>
                      handleInputChange(e, "previous_loan_account")
                    }
                  />
                  <div
                    className="errorTxt"
                    id={`error_previous_loan_account_${payCount}`}
                  ></div>
                </td>
              ) : (
                <td>
                  {previous_loan_account === "" ? "NA" : previous_loan_account}
                </td>
              )}

              {state.addedTrancheChecklist && (
                <FormTriggers
                  triggerName={previousLoanAccount}
                  disabled={false}
                  errorClass={
                    formFieldState[idx].showPreviousLoanAccountTriggerError
                      ? "has-error"
                      : ""
                  }
                  triggerValues={checkpoints.checker}
                  caseDetails={caseDetails}
                  handleTriggerChange={handleTriggerChange}
                />
              )}
            </tr>
          ) : (
            ""
          )}
          <tr>
            <td>
              Payee Name <span className="col-red">*</span>
            </td>
            {!disableMaker ? (
              <td>
                <input
                  type="text"
                  value={
                    payee_name
                      ? maskPayeeAccountText(payee_name, disableValues)
                      : ""
                  }
                  id={payeeName}
                  name={payeeName}
                  disabled={
                    formFieldState[idx]?.forceEditable ? false : disableValues
                  }
                  placeholder="Enter Payee Name"
                  title={
                    payee_name
                      ? maskPayeeAccountText(payee_name, disableValues)
                      : ""
                  }
                  pattern="^[a-zA-Z][a-zA-Z ]{2,}$"
                  className={`form-control ${
                    formFieldState[idx].payeeNameClass
                      ? formFieldState[idx].payeeNameClass
                      : ""
                  }`}
                  readOnly={formFieldState[idx].payeeNameReadOnly}
                  onChange={(e) => handleInputChange(e, "payeeNameVal")}
                  onClick={() =>
                    removeErrorClass(
                      idx,
                      "payeeName",
                      formFieldState,
                      setFormFieldState,
                      true,
                    )
                  }
                />
                <div className="errorTxt" id={`error_payee_name_${payCount}`}>
                  {formFieldState[idx].errorpayeeNameMsg
                    ? formFieldState[idx].errorpayeeNameMsg
                    : ""}
                </div>
              </td>
            ) : (
              <td>{payee_name === "" ? "NA" : payee_name}</td>
            )}
            {state.addedTrancheChecklist && (
              <FormTriggers
                triggerName={payeeName}
                disabled={false}
                errorClass={
                  formFieldState[idx].showPayeeNameTriggerError
                    ? "has-error"
                    : ""
                }
                triggerValues={checkpoints.checker}
                caseDetails={caseDetails}
                handleTriggerChange={handleTriggerChange}
              />
            )}
          </tr>
          {formFieldState[idx].payable_ac_number !== "Direct Payment" &&
          (!OfflinePaymentModes.includes(formFieldState[idx].payment_mode) ||
            !disableValues) ? (
            <tr className={`pay-details-hide-${payCount}`}>
              <td className={`${tuMatchPayeeAcNumber.class}`}>
                Payee A/C
                <span className="col-red">*</span>
              </td>

              {!disableMaker ? (
                <td>
                  <input
                    type={disableValues ? "text" : "password"}
                    value={
                      payee_ac_number
                        ? disableValues
                          ? maskString(payee_ac_number, "payee_acc_no")
                          : payee_ac_number
                        : ""
                    }
                    id={payeeAccountNo}
                    name={payeeAccountNo}
                    disabled={disableValues}
                    placeholder="Enter Account Number"
                    className={`form-control ${
                      formFieldState[idx].payeeAccountNoClass
                        ? formFieldState[idx].payeeAccountNoClass
                        : ""
                    }`}
                    onPaste={(e) => e.preventDefault()}
                    readOnly={formFieldState[idx].payeeAcNumberReadOnly}
                    onChange={(e) => handleInputChange(e, "payee_ac_number")}
                    onClick={() =>
                      removeErrorClass(
                        idx,
                        "payeeAccountNo",
                        formFieldState,
                        setFormFieldState,
                        true,
                      )
                    }
                    onBlur={() => validateAccNumberFunc(idx)}
                  />
                  <div
                    className="errorTxt"
                    id={`error_payee_ac_number_${payCount}`}
                  >
                    {formFieldState[idx].errorpayeeAccountNoMsg
                      ? formFieldState[idx].errorpayeeAccountNoMsg
                      : ""}
                  </div>
                </td>
              ) : (
                <td className={tuMatchPayeeAcNumber.class}>
                  {payee_ac_number}
                </td>
              )}
              {state.addedTrancheChecklist && (
                <FormTriggers
                  triggerName={payeeAccountNo}
                  disabled={false}
                  errorClass={
                    formFieldState[idx].showPayeeAcNumberTriggerError
                      ? "has-error"
                      : ""
                  }
                  triggerValues={checkpoints.checker}
                  caseDetails={caseDetails}
                  handleTriggerChange={handleTriggerChange}
                />
              )}
            </tr>
          ) : (
            ""
          )}
          {!disableMaker &&
          formFieldState[idx].payable_ac_number !== "Direct Payment" &&
          (!OfflinePaymentModes.includes(formFieldState[idx].payment_mode) ||
            checkPayeeNameHavAcc(payee_name) ||
            !disableValues) ? (
            <tr className="pay-details-hide-1">
              <td>
                {OfflinePaymentModes.includes(
                  formFieldState[idx].payment_mode,
                ) && disableValues
                  ? "Payee/Foreclosure A/C No"
                  : "Re-Enter Payee A/C"}
                <span className="col-red">*</span>
              </td>
              <td>
                <input
                  type="text"
                  id={`confirm_payee_ac_number_${payCount}`}
                  name={`confirm_payee_ac_number_${payCount}`}
                  value={
                    formFieldState[idx].confirmPayeeAcNumber
                      ? formFieldState[idx].confirmPayeeAcNumber
                      : ""
                  }
                  placeholder="Re-Enter Account Number"
                  className={`form-control ${
                    formFieldState[idx].confirmPayeeAcNumberClass
                      ? formFieldState[idx].confirmPayeeAcNumberClass
                      : ""
                  }`}
                  onPaste={(e) => e.preventDefault()}
                  onChange={(e) => handleInputChange(e, "confirmPayeeAcNumber")}
                  onBlur={() => validateAccNumberFunc(idx)}
                />
                <div
                  className={
                    formFieldState[idx].errorConfirmPayeeAcNumberClass
                      ? formFieldState[idx].errorConfirmPayeeAcNumberClass
                      : "errorTxt"
                  }
                  id={`error_confirm_payee_ac_number_${payCount}`}
                >
                  {formFieldState[idx].errorconfirmPayeeAcNumberMsg
                    ? formFieldState[idx].errorconfirmPayeeAcNumberMsg
                    : ""}
                </div>
              </td>
            </tr>
          ) : (
            ""
          )}
          {formFieldState[idx].payable_ac_number !== "Direct Payment" &&
          (!OfflinePaymentModes.includes(formFieldState[idx].payment_mode) ||
            !disableValues) ? (
            <tr className={`pay-details-hide-${payCount}`}>
              <td>
                IFSC Code
                <span className="col-red">*</span>
              </td>
              {!disableMaker ? (
                <td>
                  <input
                    type="text"
                    value={payee_ifsc_code?.toUpperCase()}
                    id={payeeIFSC}
                    name={payeeIFSC}
                    disabled={disableValues}
                    placeholder="Enter IFSC Code"
                    maxLength="11"
                    className={`form-control convert-to-uppercase ${
                      formFieldState[idx].payeeIFSCClass
                        ? formFieldState[idx].payeeIFSCClass
                        : ""
                    }`}
                    readOnly={formFieldState[idx].payeeIfscCodeReadOnly}
                    onChange={(e) => handleInputChange(e, "payee_ifsc_code")}
                    onClick={() =>
                      removeErrorClass(
                        idx,
                        "payeeIFSC",
                        formFieldState,
                        setFormFieldState,
                        true,
                      )
                    }
                    onBlur={() => ifscMappingFunc(idx)}
                  />
                  <div
                    className="errorTxt"
                    id={`error_payee_ifsc_code_${payCount}`}
                  >
                    {formFieldState[idx].errorpayeeIFSCMsg
                      ? formFieldState[idx].errorpayeeIFSCMsg
                      : ""}
                  </div>
                </td>
              ) : (
                <td>{payee_ifsc_code === "" ? "NA" : payee_ifsc_code}</td>
              )}
              {state.addedTrancheChecklist && (
                <FormTriggers
                  triggerName={payeeIFSC}
                  disabled={false}
                  errorClass={
                    formFieldState[idx].showPayeeIFscCodeTriggerError
                      ? "has-error"
                      : ""
                  }
                  triggerValues={checkpoints.checker}
                  caseDetails={caseDetails}
                  handleTriggerChange={handleTriggerChange}
                />
              )}
            </tr>
          ) : (
            ""
          )}
          {formFieldState[idx].payable_ac_number !== "Direct Payment" &&
          (!OfflinePaymentModes.includes(formFieldState[idx].payment_mode) ||
            !disableValues) ? (
            <tr className={`pay-details-hide-${payCount}`}>
              <td>
                Bank
                <span className="col-red">*</span>
              </td>
              {!disableMaker ? (
                <td>
                  <input
                    type="text"
                    value={payee_bank_name ? payee_bank_name : ""}
                    id={payeeBankName}
                    name={payeeBankName}
                    disabled={disableValues}
                    placeholder="Enter Bank Name"
                    className={`form-control ${
                      formFieldState[idx].payeeBankNameClass
                        ? formFieldState[idx].payeeBankNameClass
                        : ""
                    }`}
                    readOnly={formFieldState[idx].payeeBankNameReadOnly}
                    onChange={(e) => handleInputChange(e, "payee_bank_name")}
                    onClick={() =>
                      removeErrorClass(
                        idx,
                        "payeeBankName",
                        formFieldState,
                        setFormFieldState,
                        true,
                      )
                    }
                  />
                  <div
                    className="errorTxt"
                    id={`error_payee_bank_name_${payCount}`}
                  >
                    {formFieldState[idx].errorpayeeBankNameMsg
                      ? formFieldState[idx].errorpayeeBankNameMsg
                      : ""}
                  </div>
                </td>
              ) : (
                <td>{payee_bank_name === "" ? "NA" : payee_bank_name}</td>
              )}
              {state.addedTrancheChecklist && (
                <FormTriggers
                  triggerName={payeeBankName}
                  disabled={false}
                  kBankName
                  // }
                  errorClass={
                    formFieldState[idx].showPayeeBankNameTriggerError
                      ? "has-error"
                      : ""
                  }
                  triggerValues={checkpoints.checker}
                  caseDetails={caseDetails}
                  handleTriggerChange={handleTriggerChange}
                />
              )}
            </tr>
          ) : (
            ""
          )}
          {formFieldState[idx].payable_ac_number !== "Direct Payment" ? (
            <tr className={`pay-details-hide-${payCount}`}>
              <td>
                Branch
                <span className="col-red">*</span>
              </td>
              {!disableMaker ? (
                <td>
                  <input
                    type="text"
                    value={payee_branch_name ? payee_branch_name : ""}
                    id={payeeBranch}
                    name={payeeBranch}
                    disabled={
                      formFieldState[idx]?.forceEditable ? false : disableValues
                    }
                    placeholder="Enter Branch Name"
                    className={`form-control ${
                      formFieldState[idx].payeeBranchNameClass
                        ? formFieldState[idx].payeeBranchNameClass
                        : ""
                    }`}
                    readOnly={formFieldState[idx].payeeBranchNameReadOnly}
                    onChange={(e) => handleInputChange(e, "payee_branch_name")}
                  />
                  <div
                    className="errorTxt"
                    id={`error_payee_branch_name_${payCount}`}
                  >
                    {formFieldState[idx].errorpayeeBranchNameMsg
                      ? formFieldState[idx].errorpayeeBranchNameMsg
                      : ""}
                  </div>
                </td>
              ) : (
                <td>{payee_branch_name === "" ? "NA" : payee_branch_name}</td>
              )}
              {state.addedTrancheChecklist && (
                <FormTriggers
                  triggerName={payeeBranch}
                  disabled={false}
                  errorClass={
                    formFieldState[idx].showPayeeBranchNameTriggerError
                      ? "has-error"
                      : ""
                  }
                  triggerValues={checkpoints.checker}
                  caseDetails={caseDetails}
                  handleTriggerChange={handleTriggerChange}
                />
              )}
            </tr>
          ) : (
            ""
          )}

          <tr>
            <td width="20%">Payment Disb.</td>
            <td width="20%">
              <input
                type="hidden"
                value={with_held_charges ? with_held_charges : ""}
                name={`with_held_amount_${payCount}`}
                id={`with_held_amount_${payCount}`}
                onChange={(e) => handleInputChange(e, "with_held_charges")}
              />
              <input
                type="hidden"
                value={payCount}
                name="pay_count"
                id={`pay_count_${payCount}`}
                placeholder="Enter Amount"
                className="form-control"
                readOnly
              />
              <input
                type="hidden"
                value={net_amount ? net_amount : "0"}
                name={disburse_payable_amt}
                id={disburse_payable_amt}
                placeholder="Enter Amount"
                className="form-control"
                onChange={(e) => handleInputChange(e, "netAmountVal")}
              />
              <input
                type="text"
                value={paid_amount ? paid_amount : "0"}
                name={disburse_paid_amt}
                id={disburse_paid_amt}
                disabled={
                  OfflinePaymentModes.includes(
                    formFieldState[idx].payment_mode,
                  ) && disableValues
                    ? true
                    : false
                }
                placeholder="Enter Amount"
                className={`form-control disb_amt ${
                  formFieldState[idx].disbursePaidAmtClass
                    ? formFieldState[idx].disbursePaidAmtClass
                    : ""
                }`}
                readOnly={formFieldState[idx].disbursePaidAmtReadOnly}
                style={
                  formFieldState[idx].hideLastPayDiv
                    ? {
                        display: "none",
                      }
                    : {}
                }
                onChange={(e) => handleInputChange(e, "paidAmountVal")}
                onClick={(e) =>
                  removeErrorClass(
                    idx,
                    "disbursePaidAmt",
                    formFieldState,
                    setFormFieldState,
                    true,
                  )
                }
                onKeyUp={() =>
                  fetchBalAmount(
                    idx,
                    formFieldState[idx].trancheNameListData,
                    true,
                    true,
                  )
                }
                onBlur={() => compareLedgerWithDisbAmtFunc(idx)}
              />
              <div
                className="errorTxt"
                id={`error_disburse_paid_amt_${payCount}`}
              >
                {formFieldState[idx].errordisbursePaidAmtMsg
                  ? formFieldState[idx].errordisbursePaidAmtMsg
                  : ""}
              </div>
            </td>
            {state.addedTrancheChecklist && (
              <FormTriggers
                triggerName={disburse_payable_amt}
                disabled={false}
                errorClass={
                  formFieldState[idx].showDisbursePayableAmtTriggerError
                    ? "has-error"
                    : ""
                }
                triggerValues={checkpoints.checker}
                caseDetails={caseDetails}
                handleTriggerChange={handleTriggerChange}
              />
            )}
          </tr>

          {(() => {
            if (Object.keys(trancheCancellationData).length > 1) {
              const recoveredAmount = `recovered_amount_${payCount}`;
              const recovered_amount = !formFieldState[idx].recovered_amount
                ? 0
                : formFieldState[idx].recovered_amount;

              const moneyReturnedToBank = `money_returned_to_bank_${payCount}`;
              const money_returned_to_bank = formFieldState[idx]
                .money_returned_to_bank
                ? formFieldState[idx].money_returned_to_bank
                : "";

              return (
                <>
                  {!disableMaker ? (
                    <>
                      <tr>
                        <td width="20%">Recovered Amount to be Released</td>
                        <td width="20%">
                          <input
                            type="text"
                            className="form-control"
                            value={recovered_amount ? recovered_amount : "0"}
                            name="recovered_amount"
                            id={recoveredAmount}
                            onChange={(e) =>
                              handleInputChange(e, "recovered_amount")
                            }
                            onKeyUp={() =>
                              fetchBalAmount(
                                idx,
                                formFieldState[idx].trancheNameListData,
                                true,
                                true,
                              )
                            }
                          />
                        </td>
                        {state.addedTrancheChecklist && (
                          <FormTriggers
                            triggerName={recoveredAmount}
                            disabled={false}
                            errorClass={
                              formFieldState[idx]
                                .showRecoveredAmountTriggerError
                                ? "has-error"
                                : ""
                            }
                            triggerValues={checkpoints.checker}
                            caseDetails={caseDetails}
                            handleTriggerChange={handleTriggerChange}
                          />
                        )}
                      </tr>
                      <tr>
                        <td width="20%">Cancellation Charges</td>
                        <td>
                          <span class="fa fa-inr">{cancellationCharges} </span>
                          <input
                            type="hidden"
                            value={cancellationCharges}
                            name="cancellation_charges"
                            id={`cancellation_charges_${payCount}`}
                            readOnly
                          />
                        </td>
                      </tr>
                      <tr>
                        <td width="20%">Money returned to Bank</td>
                        <td width="20%">
                          <span
                            className="fa fa-inr"
                            id={`money_returned_to_bank_label_${payCount}`}
                          >
                            {formatAmount(parseInt(money_returned_to_bank))}
                          </span>
                          <input
                            type="hidden"
                            value={money_returned_to_bank}
                            name="money_returned_to_bank"
                            id={moneyReturnedToBank}
                            onChange={(e) =>
                              handleInputChange(e, "money_returned_to_bank")
                            }
                          />
                        </td>
                        {state.addedTrancheChecklist && (
                          <FormTriggers
                            triggerName={moneyReturnedToBank}
                            disabled={false}
                            errorClass={
                              formFieldState[idx]
                                .showMoneyReturnedToBankTriggerError
                                ? "has-error"
                                : ""
                            }
                            triggerValues={checkpoints.checker}
                            caseDetails={caseDetails}
                            handleTriggerChange={handleTriggerChange}
                          />
                        )}
                      </tr>
                    </>
                  ) : (
                    ""
                  )}
                </>
              );
            }
          })()}
          <tr>
            <td>Balance </td>
            <td>
              <input
                type="hidden"
                id={disburseBalAmount}
                name={disburseBalAmount}
                value={balAmount ? balAmount : ""}
                onChange={(e) => handleInputChange(e, "disburse_bal_amt")}
              />
              <span className="fa fa-inr" id={spanBalAmount}>
                {formatAmount(parseInt(balAmount))}
              </span>
            </td>
            {state.addedTrancheChecklist && (
              <FormTriggers
                triggerName={disburseBalAmount}
                disabled={false}
                errorClass={
                  formFieldState[idx].showDisburseBalAmtTriggerError
                    ? "has-error"
                    : ""
                }
                triggerValues={checkpoints.checker}
                caseDetails={caseDetails}
                handleTriggerChange={handleTriggerChange}
              />
            )}
          </tr>
          <tr>
            <td colSpan="3">
              <div className="clearfix advTxt-filter">
                <button
                  id={`addUTR${payCount}`}
                  className="advSearch-filter advSearchFilter addUTRsearch"
                  onClick={(e) => toggleUTRButton(e)}
                >
                  {!state.showUTRButton[idx] ? (
                    <span className="fa fa-plus-square-o"></span>
                  ) : (
                    <span className="fa fa-minus-square-o"></span>
                  )}
                  Add UTR / Cheque Number
                </button>
              </div>
            </td>
          </tr>
          {formFieldState[idx].showUTRButton ? (
            <tr className={`displayUtr-${payCount}`}>
              <td>UTR#</td>
              <td>
                <input
                  type="text"
                  id={payableRtgsChequeNumber}
                  value={cheque}
                  name={payableRtgsChequeNumber}
                  placeholder="UTR / Cheque Number"
                  className={`form-control ${
                    formFieldState[idx].payableRtgsChequeNumberClass
                      ? formFieldState[idx].payableRtgsChequeNumberClass
                      : ""
                  }`}
                  readOnly={formFieldState[idx].payableRtgsChequeNumberReadOnly}
                  onChange={(e) =>
                    handleInputChange(e, "payable_rtgs_cheque_number")
                  }
                  onClick={(e) =>
                    removeErrorClass(
                      idx,
                      "payableRtgsChequeNumber",
                      formFieldState,
                      setFormFieldState,
                      true,
                    )
                  }
                />
                {formFieldState[idx].errorpayableRtgsChequeNumberMsg ? (
                  <div
                    className="errorTxt"
                    id={`error_payable_rtgs_cheque_number_${payCount}`}
                  >
                    {formFieldState[idx].errorpayableRtgsChequeNumberMsg}
                  </div>
                ) : (
                  ""
                )}
              </td>
              {state.addedTrancheChecklist && (
                <FormTriggers
                  triggerName={payableRtgsChequeNumber}
                  disabled={false}
                  triggerValues={checkpoints.checker}
                  caseDetails={caseDetails}
                  handleTriggerChange={handleTriggerChange}
                />
              )}
            </tr>
          ) : (
            ""
          )}

          {state.addedTrancheChecklist &&
          user.role_id !== 9 &&
          disableMaker &&
          cheque === "" ? (
            <tr className={`displayUTRSave-${payCount}`}>
              <td colSpan="3">
                <div className="clearfix form-group utrWrapBtn">
                  <button
                    id={`utr_no_btn${payCount}`}
                    className="btn btn-edit add-utr-btn save-rto-details"
                    disabled={formFieldState[idx].disabled_utrNoBtn}
                    onClick={() => addUTR(idx)}
                  >
                    Save
                  </button>
                </div>
              </td>
            </tr>
          ) : (
            ""
          )}
        </tbody>
      </table>
    </>
  );
};

export default AddedTranche;
